module.exports = __webpack_public_path__ + "img/logo.bbb5ae98.png";